import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Amdahl's law in action - 27s to 0.03s by changing a function",
  "description": "",
  "published": "2012-08-17T00:00:00.000Z",
  "redirect_from": ["/blog/amdahls-law-in-action-27s-to-0-03s-by-changing-a-function/swizec/5106"],
  "categories": "Amdahl, Amdahl's law, Evolutionary algorithm, Haskell, Hello world program, PHP, Reddit, SQL, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Perhaps the most important lesson I've learned while studying computer science is that of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Amdahl%27s_law",
        "title": "Amdahl's law"
      }}>{`Amdahl's law`}</a>{`.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "300px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/7a00f358ee37977f8e081872ac73f9d9/5a46d/Graph-Illustrating-Amdahls-Law797aba.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "73.54260089686098%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'293\\'%20viewBox=\\'0%200%20400%20293\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20147v146h401V0H0v147M3%203L2%20148v144h397V3L201%202%203%203m171%2011c-2%204-2%204%2014%204%2014%200%2015%200%2016-2l1-2%201%202c1%203%204%203%204-1%200-2%200-2-2-2h-2l-5-1-5%201h-12l-4%201h-2c-1-2-4-2-4%200M46%20141v113h38c29%200%2037%201%2038%202l-1%201c-3%200-2%202%200%203l2%202h-2l-2%201%203%201c2%200%203-1%203-4l-1-4-1-1a3791%203791%200%2001226%202c-1%200-2%201-2%204%200%202%201%203%202%202l2%201-2%202c-2%200-3%202%200%203v1c-2%200-2%201-2%204s1%204%204%204h3v-10a1489%201489%200%2001-2-126l-1-113h-9a437%20437%200%2000-104%202l-2-2c-1%200-2%201-1%202%200%201-1%202-6%203-10%202-10%202-10-2v-3h-2v4c0%203-1%203-7%206-10%204-10%204-10-4v-6h-2v15l-5%203c-4%203-7%204-9%204h-3V40c0-11%200-13-3-11v1l1%2010v11h-17V40l1-11h-18l7%201h8v21h-17V40l-1-11-1%2011v11h-17l-1-11V29h-8c-11%200-12%201-1%201h8v21h-17V40l-1-11h-8l-8%201h15v21H86V29H65l-1%2011v11H48l-1-11-1-12v113M66%2041v10h18V30H66v11m235-10l-6%201v19h16V41c0-12%201-11-10-10m13%201l-1%209c0%2010%200%2010%2010%2010h8V30h-8c-7%200-9%200-9%202m19%208v11h17V31l-9-1h-8v10m-68-8l-8%201-1%206c0%2012%200%2012%2010%2012h8v-9l-1-10h-8m11%200v18l8%201h8V31h-7l-9%201m-34%202h-4v17h8c9%200%209%200%209-10v-7l-4-1-9%201m-16%203l-7%201v13h16v-8l-1-8-8%202m-13%203c-12%205-13%206-13%208v3h17v-5c0-6-1-7-4-6M47%2063v10h9l8%201V53H47v10m19%200v10h18V53H66v10m20%200v10h17V53H86v10m19%200v11l8-1h9V53h-17v10m18%200v10h18V53h-18v10m20%200v10h17V53h-17v10m19%200c0%2013%201%2013%2010%202s9-12-1-12h-9v10m23-7l-4%202v15h17V53h-5c-3%200-6%201-8%203m15%207v10h17V53h-17v10m19%200v10h16V63l1-10h-17v10m19%200v10h7l9%201-8%201h-8v20h17v-6l1-7v13h5c7%200%208%202%201%202l-5%201v20h8c8%200%209%200%209-2h1c2%203%2016%203%2018%200h1c1%202%203%202%209%202h8V97h-4l-5-1%205-1h4v-7l1-7%201%207v7h18V75h-5c-2%200-4%200-3-1l4-1h4V53h-18v9l-1%208-1-8v-9h-17v9c0%206%200%208-1%207l-1-8%201-8h-17v8l-1%208c-1%201-1-1-1-7v-9h-18v16l-1-8v-8h-17v10m95%200v10h17V53h-17v10m-72%2010v5l2-1h2l11%201h11v-3c0-3%200-3-3-2h-23m29%200v5l2-1h10l7%201c6%200%206%200%206-2-1-3-4-4-16-3h-9M48%2076l-1%2010v9h17V75h-8l-8%201m18%209v10h18V75H66v10m20%200v10h17V75H86v10m19%200v10h17V76l-9-1h-8v10m18%200v10h18V76l-9-1h-9v10m20%200v10h4c3%200%204%200%208-8%207-11%207-11-4-12h-8v10m21-7c-2%202-2%204-2%2010v7h17V76l-7-1c-5%200-6%200-8%203m17%207v10h17V75h-17v10m19%200v10h17V76l-9-1h-8v10m19%200v10h16V76l-8-1h-8v10m114%200v10h17V75h-17v10M47%2098v11l1%209h16V97h-8l-9%201m19%2010v10h18V97H66v11m20%200v10h17V97H86v11m19%200v10h17V97h-17v11m18-1l1%2011h14l1-3%202-11v-7h-18v10m28-9c-3%205-8%2014-8%2017v3h17V98l-4-1-5%201m11%2010v10h17V97h-17v11m19%200v10h17V97h-17v11m19%200v10h17V98l-9-1h-8v11m19%200v10h8l8-1V97h-16v11m19%200v10h17V98l-9-1h-8v11m75-10v11l1%209h17V97h-9l-9%201m20%2010v10h17V97h-17v11M48%20120l-1%2010v10h17v-21h-8l-8%201m19%200l-1%2010v10h18v-20l-9-1-8%201m19%209v11h17v-20l-9-1h-8v10m19%200v11h17v-20l-9-1h-8v10m19-9l-1%2010c0%209%200%2010%202%2010%201%200%2011-17%2011-20h-12m11%207l-5%2010-1%203h12v-10l-1-10-5%207m9-7l-1%2010v10h17v-20l-8-1-8%201m18%209v11h17v-20l-9-1h-8v10m19%200v11h17v-20l-9-1h-8v10m20-9l-1%2010v10h17v-20l-8-1-8%201m19%200l-1%2010v10h17l-1-10v-11h-7l-8%201m18%2010v10h17v-9c0-12%200-12-9-12h-8v11m19-9l-1%2010v9h18v-20l-9-1c-6%200-8%200-8%202m20-1l-1%2010v10h16v-21h-7l-8%201m17%200v11l1%209h16v-21h-8l-9%201m19%201v11l1%208h17v-21h-8c-8%200-9%200-10%202m20%209v10h17v-21h-17v11m-319-4l-1%2016%201%2015c3%200%203-2%204-16%200-13-1-14-2-15h-2m33%2027v10h17v-21H47v11m19%200v10h18v-21H66v11m20%200v10h17v-21H86v11m19%200v10h10l3-7%204-11v-3h-17v11m20-6l-2%2010v6h18v-21h-14l-2%205m18%206v10l6-3%208-4c3-2%203-3%203-9v-5h-17v11m19-6v6l8-3c8-2%209-3%209-5v-3h-17v5m122-4l-8%201v19h16v-20h-8m-41%201h-5v19h17v-19l-3-1-9%201m13%200v10l1%209h17v-20h-9l-9%201m38%200v10l1%209h16v-20h-8l-9%201m19%200v10l1%209h17v-20h-9l-9%201m20%209v10h17v-20h-17v10m-113-8l-1%209v9h16v-19h-7l-8%201m-16%201h-4v17h17v-18h-4l-9%201m-14%202c-10%202-9%201-9%209v6h17v-8c0-9%200-9-8-7m-21%205c-6%203-7%203-7%206v4h17v-6c0-7%200-7-10-4M47%20175l1%2011h16v-21H47v10m19%200l1%2011h17v-21H66v10m20%201v10h17v-21H86v11m30-10l-10%2019%205%201c8%200%2011-4%2011-14v-7h-3l-3%201m7%206l1%206%208-6%208-7h-17v7m21-6l-1%2010%201%2010h16v-21h-7l-9%201m18%2010v10h17v-21h-17v11m19%200v10h17v-21h-17v11m19-1l1%2011h16v-21h-17v10m19%200l1%2011h15v-10l1-11h-17v10m19%201v10h7c10%200%2010%200%2010-12v-9h-17v11m18-2c0%2012%200%2012%2010%2012h8v-21h-18v9m20%201l1%2011h15v-10l1-11h-17v10m18%200l1%2011h16v-21h-17v10m19-1c0%2012%200%2012%2010%2012h8v-21h-18v9m20%202v10h17v-21h-17v11m-202%200c-11%208-10%2010%201%2010h9v-9l-1-8-9%207m-83%2012l-1%2010v9h17v-20h-8l-8%201m18%209v10h18v-20H66v10m20%200l1%2010%2014-19-7-1h-8v10m26-3c-6%205-7%207-7%2010v3h17v-10c-1-12-1-12-10-3m12-6l-1%2010v9h18v-19l-9-1-8%201m19%209v10h17v-19l-9-1h-8v10m19%200v10h17v-19l-9-1h-8v10m19%200v10h17v-20h-17v10m19%200v10h17v-19l-9-1h-8v10m19%200v10h16v-19l-8-1h-8v10m19%200v10h17v-19l-9-1h-8v10m19-9l-1%2010v9h18v-20h-8l-9%201m19-1v20h16v-19c1-1-15-1-16-1m18%201v10l1%209h16v-20h-8l-9%201m19%200v10l1%209h17v-20h-9l-9%201m20%209v10h17v-20h-17v10M47%20210v11l1%209h16v-21h-8l-9%201m19%200v11l1%208%208-8c12-10%2012-11%200-12l-9%201m25%204c-4%204-5%206-5%209v3l7-3c10-3%2010-3%2010-9%200-4-1-5-3-5-3%200-4%201-9%205m14%200c0%206-1%206%2011%202%205-2%206-2%206-4s-1-3-9-3h-8v5m81-3h-5v19h17v-20h-4l-8%201m14%209l1%2010h16v-19l-9-1h-8v10m19%200l1%2010h15v-20h-16v10m19%200v10h7c10%200%2010%200%2010-10s0-10-9-10h-8v10m19-8v17l9%201h8v-20h-8c-7%200-9%200-9%202m19%207v10l9%201h7v-20h-16v9m18-8v10l1%209h16v-20h-8l-9%201m19%200v10l1%209h17v-20h-9l-9%201m20%209v10h17v-20h-17v10m-167-8h-4v18h17v-18l-4-1-9%201m-11%201l-8%201h-4v16h17v-8c0-10%200-10-5-9m-16%202l-9%201-7%201v13h18v-7c0-8%200-9-2-8m-27%205l-6%202-1%204v4h17v-6c0-7%200-7-10-4m55%2013h-5v19h17v-19l-3-1-9%201m14%209v10h17v-19l-9-1h-8v10m20-9l-1%2010v9h17v-19l-8-1-8%201m18%209v10h17l-1-10v-10h-16v10m19%200v10h17v-19l-9-1h-8v10m19-9l-1%2010v9h18v-19l-9-1-8%201m19%209v10h17l-1-10v-10h-16v10m19-9l-1%2010v9h17v-20h-8l-8%201m19%200l-1%2010v9h18v-20h-8l-9%201m19%209v10h17v-20h-17v10m-209-8l-1%209v9h18v-19h-8l-9%201m19%209v9h17v-19h-17v10m-38%200v9h17v-18h-17v9m-14-7h-5v16h17v-17h-4l-8%201m-18%202l-6%202-1%206v6h18v-7c0-9%201-9-11-7m-17%203c-9%202-9%202-9%207v4h17v-6c0-7%200-6-8-5m273%2015v11c-1%2010%200%2012%202%2010h2l1%201c1-4%201-8-1-8l-3-2h2c2%201%203%200%201-2v-1c1-2%202-4%201-8l-5-1m-170%2029c0%202%202%203%2017%202%208%200%2010%200%2010-2%201-2%202-2-13-2l-14-1v3m39-1c0%203%202%204%204%202h32l2%201c2%200%202-1%202-2s-2-2-15-2h-20c-5-1-5-1-5%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7a00f358ee37977f8e081872ac73f9d9/ca0a1/Graph-Illustrating-Amdahls-Law797aba.webp 223w", "/static/7a00f358ee37977f8e081872ac73f9d9/c85cb/Graph-Illustrating-Amdahls-Law797aba.webp 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7a00f358ee37977f8e081872ac73f9d9/e92b6/Graph-Illustrating-Amdahls-Law797aba.png 223w", "/static/7a00f358ee37977f8e081872ac73f9d9/5a46d/Graph-Illustrating-Amdahls-Law797aba.png 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7a00f358ee37977f8e081872ac73f9d9/5a46d/Graph-Illustrating-Amdahls-Law797aba.png",
                "alt": "Graph Illustrating Amdahl's Law",
                "title": "Graph Illustrating Amdahl's Law",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Graph Illustrating Amdahl's Law`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "104px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/633f92472a1f09965d3fe09aa4676e60/c6fc0/Amdahls-lawfe44ba.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.11538461538461%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'188\\'%20viewBox=\\'0%200%20400%20188\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M200%201c0%202-5%206-9%207-3%201-3%203%201%204l3%201%201%2036-3%201c-3%200-5%203-3%204h21c2-1%200-4-3-4h-3V0h-2l-3%201M0%2087v3h401v-6H0v3m360%2010c-2%202-2%202%200%203v5l-2%208-2%208-2%204-2%202c-2%202-2%202-1%204%205%203%2014%201%2012-3v-10c0-2%201-2%207-2%2014%200%2023-10%2015-17-3-3-23-4-25-2m7%205l-1%205v5h5c5%200%2010-4%2010-8%200-2-1-3-7-3l-7%201m-347%204l-3%204-2%203-1%202-2%204-2%205c-3%203-3%2035-1%2037l2%205%203%204%201%201c0%203%205%209%207%209%203%200%203-5%200-6l-2-3-2-3-2-7-2-8c-2-3-1-18%201-22l1-7%201-5%203-5%203-4c1-1%201-5-1-6l-2%202m204%200l1%202%202%202%202%203%202%204%202%204c1%202%202%205%202%2021%200%2017-1%2020-2%2022l-2%204-2%204-2%204-1%202c-2%200-2%203-1%203l2-1%202-2%202-1%203-3%202-5%201-3%202-5%203-8c2-6%201-17-1-24l-2-8-1-3-2-2-2-4-3-4-3-2c-3-2-3-2-4%200m-174%203l-7%206-3%201c-3%202-1%204%203%204l3%201-1%2036-3%201-3%202c0%202%209%203%2017%202%207%200%208-3%202-4l-2-1-1-24-1-25-4%201m129%200c-2%201-1%202%202%204%203%201%203%201%202%203l-2%208-2%208-2%208-2%208-2%205c0%204-1%205-4%205-4%200-4%203-1%204h14c3%200%204-3%202-4s-2-6-1-10l2-6c1-3%201-3%209-3%2012%200%2019-3%2024-12%203-5%203-8%200-12-5-7-5-7-23-7l-16%201m13%205c-1%201-2%202-3%208l-2%209c-2%203-1%204%208%204%207%200%207%200%2010-3l3-4%201-2c6-6%201-14-9-14l-8%202m101%206l-1%2012v10h-9c-11%200-13%200-13%203%200%202%201%202%2011%202h11v10c0%2011%201%2014%203%2013s2-3%202-12l1-10%2011-1c10%200%2011-1%2011-2%200-2-1-3-12-3h-11v-11c0-11-1-14-4-11m54%2019c-3%204%200%204%2021%204h21v-2c0-2-1-3-21-3l-21%201m-255%204c-1%204%201%204%2024%204%2022%200%2026-1%2021-4-2-2-44-2-45%200m272%2014c-7%208-7%208-3%2013%203%203%204%204%207%204%205%200%208%203%206%208-1%203-2%203-8%203-7%200-7%200-7-2%200-3-2-5-3-5-2%201-2%202-2%205v5h10l11-1c3-3%207-8%207-10%200-3-6-8-8-8-4%200-9-5-8-8%201-2%201-3%206-3%204%200%205%200%207%203%203%205%206%205%206-1v-5l-9-1c-8%200-9%200-12%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/633f92472a1f09965d3fe09aa4676e60/d179f/Amdahls-lawfe44ba.webp 104w"],
                "sizes": "(max-width: 104px) 100vw, 104px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/633f92472a1f09965d3fe09aa4676e60/c6fc0/Amdahls-lawfe44ba.png 104w"],
                "sizes": "(max-width: 104px) 100vw, 104px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/633f92472a1f09965d3fe09aa4676e60/c6fc0/Amdahls-lawfe44ba.png",
                "alt": "Amdahl's law",
                "title": "Amdahl's law",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Amdahl's law`}</figcaption>{`
  `}</figure></p>
    <p>{`Amdahl's law is generally used to predict the maximum speedup by improving a single component of a system (say, a function or a database). But the implications are simple: `}<em parentName="p">{`Improve the thing that will `}<strong parentName="em">{`actually`}</strong>{` help.`}</em></p>
    <p>{`As programmers, however, we would rather contemplate just what is `}<a parentName="p" {...{
        "href": "http://www.codinghorror.com/blog/2009/01/the-sad-tragedy-of-micro-optimization-theater.html"
      }}>{`the fastest way to concatenate a string`}</a>{`. Or whether `}<a parentName="p" {...{
        "href": "http://www.php.net",
        "title": "PHP"
      }}>{`PHP`}</a>{` is much faster than Ruby. And just how much more traffic you can handle with 5 or 10 fcgi workers. And so on. The internet is riddled with these questions. And let's not forget the age old debate of speed improvements by using raw `}<a parentName="p" {...{
        "href": "http://www.iso.org/iso/catalogue_detail.htm?csnumber=45498",
        "title": "SQL"
      }}>{`SQL`}</a>{` instead of an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Object-relational_mapping",
        "title": "Object-relational mapping"
      }}>{`ORM`}</a>{`.`}</p>
    <p>{`Once upon a time I even wrote a web framework where I made sure to `}<em parentName="p">{`always use the fastest pattern of doing X in PHP`}</em>{`. I knew databases were slow, so I did a lot of the work regarding JOINs and such in PHP.`}</p>
    <p>{`Yeah.`}</p>
    <h2 {...{
      "id": "optimizing-where-it-matters"
    }}>{`Optimizing where it matters`}</h2>
    <p>{`The other day I finally assembled all the bits and pieces for an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Evolutionary_algorithm",
        "title": "Evolutionary algorithm"
      }}>{`evolutionary algorithm`}</a>{` in `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`.`}</p>
    <p>{`I'm trying to print `}<em parentName="p"><a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Hello_world_program",
          "title": "Hello world program"
        }}>{`Hello World`}</a></em>{` by performing random changes on a population of strings - eventually I want to create an extensible framework for evolutionary algorithms that will let me `}<a parentName="p" {...{
        "href": "http://swizec.github.com/Le-Thesis/"
      }}>{`write poetry programmatically`}</a>{`.`}</p>
    <p>{`It took `}<strong parentName="p">{`27 seconds`}</strong>{` to go 5 epochs. Just five generations.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-log"
      }}>{`  INIT    time    0.00s  (  0.00s elapsed)
  MUT     time   26.47s  ( 27.00s elapsed)
  GC      time    0.62s  (  0.62s elapsed)
  EXIT    time    0.00s  (  0.00s elapsed)
  Total   time   27.08s  ( 27.62s elapsed)

  %GC     time       2.3%  (2.2% elapsed)

  Productivity  97.7% of total user, 95.8% of total elapsed
`}</code></pre>
    <p>{`Okay, it's definitely not a problem with memory access. 97.7% of the time is spent in computation, this is good, but slightly worrying. Let's do some profiling!`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-log"
      }}>{`COST CENTRE   MODULE           %time %alloc

levenshtein   Evaluators.Basic  91.5  100.0
levenshtein.d Evaluators.Basic   8.5    0.0
`}</code></pre>
    <p>{`The `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/levenshtein-distance-in-haskell/swizec/4801",
        "title": "Levenshtein distance in Haskell"
      }}>{`levenshtein distance function I implemented`}</a>{` costs 100% of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Time_complexity",
        "title": "Time complexity"
      }}>{`computation time`}</a>{`!`}</p>
    <p>{`After replacing my function with `}<a parentName="p" {...{
        "href": "http://www.reddit.com/r/programming/comments/w4gs6/levenshtein_distance_in_haskell/c5a6jjz"
      }}>{`the implementation suggested by Reddit`}</a>{` life instantly became much easier. It now takes just 0.03 seconds to compute 5 epochs of the algorithm.`}</p>
    <p><strong parentName="p">{`27 seconds -> 0.03 seconds by changing a single function.`}</strong></p>
    <p>{`The problem I have now is anything larger than ~25 epochs makes my computer decide something funny is going and kill the program, which says I'm doing something terrible with memory.`}</p>
    <p>{`Then again, there `}<em parentName="p">{`are`}</em>{` 480195 population members at the 25th epoch ... I probably don't need that many.`}</p>
    <p>{`By the way, it's still not a memory problem per se (for 20 epochs):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-log"
      }}>{`  Total   time   10.72s  ( 10.80s elapsed)

  %GC     time      23.4%  (23.3% elapsed)

  Alloc rate    2,736,341,212 bytes per MUT second

  Productivity  76.6% of total user, 76.0% of total elapsed

-----

COST CENTRE    MODULE           %time %alloc

lev'''.lev     Evaluators.Basic  61.5   58.8
lev'''.levMemo Evaluators.Basic  17.3   31.4
breedTwo       Operators.Basic    2.8    2.4
breedTwo.(...) Operators.Basic    2.0    0.6
breedTwo.(...) Operators.Basic    1.3    0.6
breedTwo.(...) Operators.Basic    1.3    0.6
select.\\       Selectors.Basic    1.1    0.3
lev'''.xa      Evaluators.Basic   1.1    0.6
`}</code></pre>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/levenshtein-distance-in-haskell/swizec/4801"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/98768579_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/levenshtein-distance-in-haskell/swizec/4801"
        }}>{`Levenshtein distance in Haskell`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.pdark.de/2012/06/29/jazoon-2012-divideconquer-efficient-java-for-multicore-world/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/97318522_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.pdark.de/2012/06/29/jazoon-2012-divideconquer-efficient-java-for-multicore-world/"
        }}>{`Jazoon 2012: Divide&Conquer: Efficient Java for Multicore World`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/an-elegant-way-to-randomly-change-every-list-member-in-haskell/swizec/5060"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/106367996_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/an-elegant-way-to-randomly-change-every-list-member-in-haskell/swizec/5060"
        }}>{`An elegant way to randomly change every list member in Haskell`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.kejser.org/2012/07/16/how-vertical-partitioning-and-deep-joins-kill-parallelism/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100761108_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.kejser.org/2012/07/16/how-vertical-partitioning-and-deep-joins-kill-parallelism/"
        }}>{`How Vertical Partitioning and Deep Joins Kill Parallelism`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://plumbr.eu/blog/let-them-talk"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/97839111_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://plumbr.eu/blog/let-them-talk"
        }}>{`Let them talk`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.codecentric.de/en/2012/07/10-application-performance-tuning-tips/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_116_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.codecentric.de/en/2012/07/10-application-performance-tuning-tips/"
        }}>{`10 Application Performance Tuning Tips`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0ef6e9d4-09b7-4153-a0af-d9a65c1facb9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      